import { InputLabel, Typography } from "@mui/material";
import cx from "clsx";

export type FormControlLabelComponentProps = Omit<
  React.HTMLAttributes<HTMLLabelElement>,
  "color"
>;

interface FormControlLabelProps {
  label: React.ReactNode;
  id: string;
  labelProps?: FormControlLabelComponentProps;
  className?: string;
}

export const FormControlLabel = ({
  label,
  id,
  labelProps = {},
  className,
}: FormControlLabelProps) => {
  if (!label) return null;

  const clsx = cx(className, "mb-1");

  return (
    <InputLabel
      className={clsx}
      htmlFor={id}
      style={{
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "clip",
      }}
      {...labelProps}
    >
      <Typography color="neutral.contrastText" variant="text_md_m">
        {label}
      </Typography>
    </InputLabel>
  );
};
